import React from 'react';
import "./SectionTitle.css"

export default function SectionTitle({title}) {
    return (
        <div className="section-title w-100 ">
            {title}
        </div>
    )
}
